import React from "react";

function Footer(){
    return(
        <div className="Footer">
                <footer className="page-footer font-small text-center special-color-dark">
                            <p style={{ margin: 0, padding: "14px 0", fontSize: "13px", color: "#666" }}>
                                © { new Date().getFullYear() }. All rights reserved.
                            </p>
                </footer>
                {}
        </div>
    )
}

export default Footer;